import React from 'react';
import styled from 'styled-components';

import { Button } from 'playup-web-core';

import QuestionsAndHelp from '../USFooter/QuestionsAndHelp';

const USDepositErrorModal = ({ getBackToHomePage }: Props) => {
	return (
		<DepositErrorContainer>
			<NormalText>We could not process your deposit request.</NormalText>
			<NormalText>Please try again or use a different payment method.</NormalText>
			<StyledButton kind="playup" type="submit" height={50} onClick={getBackToHomePage}>
				TRY AGAIN
			</StyledButton>
			<QuestionsAndHelp />
		</DepositErrorContainer>
	);
};

interface Props {
	getBackToHomePage: () => void;
}

export default USDepositErrorModal;

const DepositErrorContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const NormalText = styled.p`
	margin-bottom: 8px;
`;

const StyledButton = styled(Button)`
	margin: 20px auto;
`;
